import React, { useLayoutEffect, useState } from "react";
import FlowEdge from "../../../workflows/CreateCampaign/flowHorizontal/edges/FlowEdge";
import TrailEdge from "../../../workflows/CreateCampaign/flowHorizontal/edges/TrailEdge";
import StartNode from "../../../workflows/CreateCampaign/flowHorizontal/nodes/StartNode";
import TrailNode from "../../../workflows/CreateCampaign/flowHorizontal/nodes/TrailNode";
import BaseNode from "../../../workflows/CreateCampaign/flowHorizontal/nodes/BaseNode";
import { handleLayout } from "../../../workflows/CreateCampaign/flowHorizontal/layouter";
import {
  Button,
  Flex,
  Group,
  Modal,
  Paper,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import ReactFlow, { Background, Controls, ReactFlowProvider } from "reactflow";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import BackButton from "../../../../../components/View/BackButton";
import {
  IconArrowRight,
  IconSwitchVertical,
  IconUserCancel,
  IconUserExclamation,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import WorkflowListingModal from "../../../workflows/listing/WorkflowListingModal";
import FirstStepCreation from "../../../workflows/CreateCampaign/flowHorizontal/onboarding/FirstStepCreation";
import { getDefaultZoom } from "../../../workflows/CreateCampaign/flowHorizontal/flowUtils";

const edgeTypes = {
  main: FlowEdge,
  trail: TrailEdge,
};

const nodeTypes = {
  start: StartNode,
  trail: TrailNode,
  action: BaseNode,
};

const NurturingFlowHorizontal = ({ nurturing, setActiveStep }) => {
  const lang = useLanguage((s) => s.language);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const flowProfile = useFlowStore((s) => s.profile);
  const loadingPage = useFlowStore((s) => s.loadingPage);

  const handleSwitch = () => {
    useFlowStore.getState().setLayout("vertical");
  };

  useLayoutEffect(() => {
    handleLayout();

    let minStateButton = document.getElementById("min-state-button");

    if (minStateButton) {
      minStateButton.click();
    }
  }, []);

  return (
    <>
      <Paper component={Group} p={"md"} gap={"xl"} withBorder>
        <Title order={4}>{lang.prm.nurturing.step3.title}</Title>
        <Text>{lang.prm.nurturing.step3.text}</Text>
      </Paper>
      <Flex
        flex={1}
        style={{ overflow: "hidden" }}
        mah={
          nurturing?.id === "create"
            ? "calc(100vh - 290px)"
            : "calc(100vh - 300px)"
        }
      >
        <Tooltip
          label={lang.workflows.configs.exclude_answerers}
          refProp="rootRef"
        >
          <Switch
            key={flowProfile?.id}
            size="md"
            onLabel={<IconUserCancel size={18} />}
            offLabel={<IconUserExclamation size={18} />}
            defaultChecked={flowProfile.auto_remove_responders}
            onChange={(e) =>
              useFlowStore.getState().setProfile({
                ...useFlowStore.getState().profile,
                auto_remove_responders: e.target.checked,
              })
            }
            name="auto_remove_responders"
            pos={"absolute"}
            left={4}
            style={{ zIndex: 8 }}
          />
        </Tooltip>
        <ReactFlowProvider>
          <ReactFlow
            id="workflow"
            nodes={nodes.filter((x) => x.type !== "trail")}
            nodeTypes={nodeTypes}
            edges={edges}
            // onNodesChange={handleNodesChange}
            connectOnClick={false}
            panOnScroll
            panOnScrollMode="vertical"
            panOnDrag={true}
            zoomOnScroll={false}
            preventScrolling
            // fitView
            defaultEdgeOptions={{
              type: "main",
              deletable: false,
              focusable: false,
              updatable: false,
            }}
            edgeTypes={edgeTypes}
            disableKeyboardA11y
            nodesDraggable={false}
            proOptions={{
              hideAttribution: true,
            }}
            defaultViewport={{
              x: 0,
              y: 0,
              zoom: getDefaultZoom(),
            }}
            translateExtent={[
              [-Infinity, 32],
              [Infinity, Infinity],
            ]}
            nodeExtent={[
              [-Infinity, 32],
              [Infinity, Infinity],
            ]}
            maxZoom={1}
            edgesUpdatable={false}
            edgesFocusable={false}
          >
            <Background />
            <Controls position="bottom-right" showInteractive={false} />

            {((nodes.length === 1 && nodes[0].type === "start") ||
              nodes.length === 0) &&
              !loadingPage && <FirstStepCreation isManual />}
            <Button
              pos={"fixed"}
              top={256}
              right={100}
              style={{ zIndex: 600 }}
              rightSection={<IconSwitchVertical size={16} />}
              variant="outline"
              bg={"#fff"}
              size="sm"
              onClick={handleSwitch}
              radius={"lg"}
            >
              {lang.campaign.popup_new.btn_change_to_old}
            </Button>
          </ReactFlow>
        </ReactFlowProvider>

        <WorkflowListingModal nurturing />

        <Paper
          component={Group}
          p={"md"}
          mt={"md"}
          gap={"lg"}
          pos={"absolute"}
          bottom={16}
          left={16}
        >
          <BackButton
            label={lang.global.back}
            onClick={() => setActiveStep("contacts")}
            size="md"
          />

          <Button
            onClick={() => setActiveStep("program")}
            size="md"
            rightSection={<IconArrowRight />}
          >
            {lang.global.next}
          </Button>
        </Paper>
      </Flex>
    </>
  );
};

export default NurturingFlowHorizontal;
